import * as tslib_1 from "tslib";
import { IgrGridColumnOptionsSectionBase } from "./igr-grid-column-options-section-base";
import { ensureBool } from "igniteui-react-core";
var IgrGridColumnOptionsSimpleSectionBase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrGridColumnOptionsSimpleSectionBase, _super);
    function IgrGridColumnOptionsSimpleSectionBase(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(IgrGridColumnOptionsSimpleSectionBase.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridColumnOptionsSimpleSectionBase.prototype, "caption", {
        get: function () {
            return this.i.bs;
        },
        set: function (v) {
            this.i.bs = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridColumnOptionsSimpleSectionBase.prototype, "showCaption", {
        get: function () {
            return this.i.bq;
        },
        set: function (v) {
            this.i.bq = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridColumnOptionsSimpleSectionBase;
}(IgrGridColumnOptionsSectionBase));
export { IgrGridColumnOptionsSimpleSectionBase };
//# sourceMappingURL=igr-grid-column-options-simple-section-base.js.map
